// extracted by mini-css-extract-plugin
module.exports = {"brandcolor":"#163194","brandcolor2":"#2699FB","mainbackgroundcolor":"#fff","book-contact":"bg_dx","bookContact":"bg_dx","book-contact-icon":"bg_dy","bookContactIcon":"bg_dy"};